import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { reviewApi } from "./api";
export default function BetaFeedback({
  id,
  initial,
}: {
  id: string;
  initial?: { rating: number; comment: string } | null;
}) {
  const [rating, setRating] = useState(initial ? String(initial.rating) : ""),
    [comment, setComment] = useState(initial?.comment || ""),
    [status, setStatus] = useState("");
  return (
    <form
      className="reviewed-note mt-4"
      onSubmit={async e => {
        e.preventDefault();
        setStatus("Saving…");
        try {
          await reviewApi(`/${id}/feedback`, "POST", {
            rating: Number(rating),
            comment,
          });
          setStatus("Thanks — your feedback was saved.");
        } catch (e: any) {
          setStatus(e.message);
        }
      }}
    >
      <h3 className="h6">How was the test review?</h3>
      <p className="small">
        Optional feedback for the Reviewed team. Please omit confidential facts.
      </p>
      <Form.Select
        aria-label="Review experience rating"
        required
        value={rating}
        onChange={e => setRating(e.target.value)}
      >
        <option value="">Choose a rating</option>
        {[1, 2, 3, 4, 5].map(n => (
          <option key={n} value={n}>
            {n} —{" "}
            {
              [
                "Confusing",
                "Somewhat confusing",
                "Mixed",
                "Clear",
                "Very clear",
              ][n - 1]
            }
          </option>
        ))}
      </Form.Select>
      <Form.Control
        className="my-2"
        aria-label="Review feedback"
        as="textarea"
        rows={2}
        maxLength={2000}
        value={comment}
        onChange={e => setComment(e.target.value)}
        placeholder="What could be simpler?"
      />
      <Button type="submit" disabled={!rating || status === "Saving…"}>
        {initial ? "Update feedback" : "Send feedback"}
      </Button>
      {status && (
        <p role="status" className="mt-2">
          {status}
        </p>
      )}
    </form>
  );
}
